//
//  src/layouts/default/about/About.js
//
import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Nav      from "../../../components/nav/Nav"
import Footer   from "../../../components/footer/Footer"
import Profile  from "../../../components/profile/Profile"


//
//  about
//
export default function About() {
    const location = useLocation();
    const canonicalUrl = `https://jefftattooer.com${location.pathname}`.replace(/\/$/, '') || 'https://jefftattooer.com/about';
    const ogImage = 'https://jefftattooer.com/logo512.png';
    const pageTitle = 'About Jeff Tattooer | Professional Tattoo Artist';
    const pageDescription = 'Learn about Jeff Tattooer, a professional tattoo artist specializing in realistic tattoo artwork, blackwork, traditional, and neo-traditional designs.';
    
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": pageTitle,
        "description": pageDescription,
        "url": canonicalUrl,
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://jefftattooer.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "About",
                    "item": canonicalUrl
                }
            ]
        }
    };
    
    return (
        <div id="about">
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={canonicalUrl} />
                
                {/* Open Graph */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Jeff Tattooer" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={ogImage} />
                
                {/* Structured Data */}
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <Nav      />
            <Profile  />
            <Footer   />
        </div>
    );
}
